module.exports = __webpack_public_path__ + "img/icon-questions-no-ticket.ca8d69ef.png";